import { faPercent } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a percent icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/percent?f=classic&s=solid
 */
export const PercentIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faPercent} {...props} />;
};
